<template>
    <div class="publicZone">
        <public-skeleton v-if="loading" style="margin-top: 30px"></public-skeleton>
        <div v-else>
            <div class="container">
                <div class="home-header">
                    <van-search shape="round" class="header-search" left-icon="/static/bytx/public/search_black.svg" @click="search" v-model="value" placeholder="查找救助项目"/>
                </div>
            </div>
            <div class="section1">
                <!--消息滚动栏 -->
                <div class="message">
                    <div class="message-left">
                        <img src="/static/bytx/public/welfare_new_icon.svg">
                    </div>
                    <div class="message-right">
                        <van-swipe style="height: 70px;" vertical :autoplay="3000" :show-indicators="false">
                            <van-swipe-item v-for="(item, index) in messageArr" :key="index">
                                <div class="item">
                                    <div class="desc">
                                        <p>{{ item.message.substring(0, item.message.indexOf('【'))}}
                                            <span>{{ item.message.substring(item.message.indexOf('【'), item.message.indexOf('】') + 1) }}</span>
                                            {{ item.message.substring(item.message.indexOf('】') + 1, item.message.length) }}
                                        </p>
                                    </div>
                                    <div class="time">
                                        {{ item.duration_str }}
                                    </div>
                                </div>
                            </van-swipe-item>
                        </van-swipe>
                    </div>
                </div>
                <!--用户入口 -->
                <div class="user">
                    <div class="user-left">
                        <div class="title">我是患者/家属</div>
                        <div class="top" @click="goList('medical-assistance', 'icon')">
                            <div class="top-icon">
                                <img src="static/bytx/public/welfare_icon_1.svg">
                            </div>
                            <div class="top-text">
                                <p>救助项目</p>
                                <p>经济救助 生活帮扶</p>
                            </div>
                        </div>
                        <div class="top" @click="goList('story')">
                            <div class="top-icon">
                                <img src="static/bytx/public/welfare_icon_2.svg">
                            </div>
                            <div class="top-text">
                                <p>病友故事</p>
                                <p>真实经历 增强信心</p>
                            </div>
                        </div>
                    </div>
                    <div class="user-right">
                        <div class="title">我是捐赠人</div>
                        <div class="top" @click="goList(2, 'icon')">
                            <div class="top-icon">
                                <img src="static/bytx/public/welfare_icon_3.svg">
                            </div>
                            <div class="top-text">
                                <p>捐赠通道</p>
                                <p>用善举托起生命的希望</p>
                            </div>
                        </div>
                        <div class="top" @click="goList(1, 'icon')">
                            <div class="top-icon">
                                <img src="static/bytx/public/welfare_icon_4.svg">
                            </div>
                            <div class="top-text">
                                <p>爱心集市</p>
                                <p>用爱认捐TA的心意</p>
                            </div>
                        </div>
                    </div>
                </div>
                <!--广告位 -->
                <div class="ad">
                    <!--          <div class="ad-wrap" ref="adWrap">-->
                    <div class="ad-box" v-for="(item, index) in banners" :key="index" @click="clickAd(item)">
                        <!-- <a :href="item.link">-->
                        <a @click.prevent="toLink(item.link)">
                            <img :src="item.img" alt="">
                            <p>{{ item.title }}</p>
                            <p>{{ item.desc }}</p>
                        </a>
                        <!-- </a> -->
                    </div>
                    <!--            <van-swipe :loop="false" :width="180" :show-indicators="false">-->
                    <!--              <van-swipe-item v-for="(item, index) in banners" :key="index" @click="clickAd(item)">-->
                    <!--                              <a :href="item.link">-->
                    <!--                                <img :src="item.img" alt="">-->
                    <!--                                <p>{{ item.title }}</p>-->
                    <!--                                <p>{{ item.desc }}</p>-->
                    <!--                              </a>-->
                    <!--              </van-swipe-item>-->
                    <!--            </van-swipe>-->
                    <!--          </div>-->
                    <!--          <div class="ad-wrap">-->
                    <!--            <vue-seamless-scroll :data="banners" :class-option="classOption">-->
                    <!--              <div class="ad-wrap-box" v-for="(item, index) in banners" :key="index">-->
                    <!--                <a :href="item.link">-->
                    <!--                  <img :src="item.img" alt="">-->
                    <!--                  <p>{{ item.title }}</p>-->
                    <!--                  <p>{{ item.desc }}</p>-->
                    <!--                </a>-->
                    <!--              </div>-->
                    <!--            </vue-seamless-scroll>-->
                    <!--          </div>-->
                </div>
            </div>
            <!--救助项目 -->
            <div class="help">
                <div class="help-title">
                    <div class="help-title-left">
                        <span>救助项目</span>
                    </div>
                    <div class="help-title-right" @click="goList('medical-assistance', 'more')">
                        <span>查看全部</span>
                        <img src="/static/bytx/public/welfare_list_more_1.svg" alt="">
                    </div>
                </div>
                <div class="help-content">
                    <div class="help-content-top">
                        <div class="help-content-top-left">
                            <van-tabs :swipeable="true" v-model="category_index" @change="tabChange">
                                <van-tab :title-class="'course-list-category-title'" v-for="(item,index) in categories" :key="index" :title="item.name" ></van-tab>
                            </van-tabs>
                        </div>
                    </div>
                    <div class="help-content-box" v-for="(item, index) in helpArr" :key="index" @click="go_detail(item)">
                        <div v-if="index == 0" class="help-content-box-first" style="margin-top: 12px;margin-bottom: 3px">
                            <img :src="item.cover_img" width="100%" alt="">
                            <div class="help-content-box-first-bot">
                                <div> {{ item.title }}</div>
                                <div>
                                    <span class="desc">{{ item.desc }}</span>
                                    <img class="apply" src="/static/bytx/welfare_sqjz_btn.svg" alt="" @click.stop="applyHelp(item)">
                                </div>
                            </div>
                            <div class="help-content-box-first-icon">
                                <img src="/static/bytx/public/tag_live_best_icon.svg" alt="">
                            </div>
                        </div>
                        <div v-else class="help-content-box-other">
                            <div class="help-content-box-other-img">
                                <img :src="item.cover_img" alt="">
                            </div>
                            <div class="help-content-box-other-text">
                                <div class="help-content-box-other-text-top">
                                    <div>{{ item.title }}</div>
                                    <div>{{item.desc ? item.desc : '为爱点亮希望'}}</div>
                                </div>
                                <div class="help-content-box-other-text-bot">
                                    <img src="/static/bytx/public/welfare_help_icon_2.svg">
                                    <span @click.stop="applyHelp(item)">申请救助</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--公益行动-->
            <div class="action">
                <div class="action-title">
                    <span class="action-title-left">公益行动</span>
                    <div class="action-title-right" @click="goList('what-we-do')">
                        <span>查看全部</span>
                        <img src="/static/bytx/public/welfare_list_more_1.svg" alt="">
                    </div>
                </div>
                <div class="action-content">
                    <div class="action-content-box" v-for="(item,i) in community_activity" :key="item.id">
                        <div v-if="item.content_type === 2" class="article-list-section" style="padding-bottom: 0">
                            <van-row class="article-list-section-box" @click="go_article_detail(item)">
                                <van-col span="8">
                                    <van-image
                                        fit="cover"
                                        class="article-list-content-img"
                                        :src="item.cover_img"
                                        width="100%"
                                        height="74"
                                    />
                                    <div class="article-list-section-left-zl" v-if="item.type == 2">
                                        图文专题
                                    </div>
                                    <div class="article-list-section-left-zl" v-else>
                                        精彩图文
                                    </div>
                                </van-col>
                                <van-col span="16" class="article-list-content">
                                    <div class="article-list-title">{{item.title}}</div>
                                    <div class="article-list-content-detail">
                                        <div>{{item.created_at.substring(0,10)}}<span style="margin-left: 8px">{{item.view_count}}人阅读</span></div>
                                    </div>
                                </van-col>
                            </van-row>
                        </div>

                        <div class="live-list-section" v-if="item.content_type === 4" style="padding-bottom: 0">
                            <van-row @click="go_live_detail(item)">
                                <div class="live-list-section-box" style="padding-bottom: 0">
                                    <div class="live-list-section-left">
                                        <img class="live-list-section-left-img" :src="item.cover_img">
                                        <div v-if="item.type==2" class="live-list-section-left-zl">直播专题</div>
                                        <div v-else-if="item.live_status==0" class="live-list-section-left-zl">直播预告</div>
                                        <div v-else-if="item.live_status==1" class="live-list-section-left-zl">
                                            <img src="/static/bytx/activity_list_live_icon.gif" alt=""> 直播中
                                        </div>
                                        <div v-else class="live-list-section-left-zl">
                                            直播回放
                                        </div>
                                        <div class="live-list-section-left-time" v-if="item.live_status>1"><span>{{item.duration_format}}</span></div>
                                    </div>
                                    <div class="live-list-section-right">
                                        <div class="live-list-section-right-title" v-html="item.title"></div>
                                        <div class="live-list-section-right-detail" style="bottom: 0">
                                            <span v-if="item.type === 2">共{{item.total_count}}期</span>
                                            <span v-else-if="item.live_status < 2">{{item.start_at.substring(0,16)}}</span>
                                            <span v-else>{{item.view_count}}人观看</span>
                                            <span class="live-list-section-right-detail-join" v-if="item.type != 2 && item.live_status < 2">
                            <span>{{item.live_status === 0 ? item.isAppointment ? '已预约':'预约' : '加入'}}</span>
                        </span>
                                        </div>
                                    </div>
                                </div>
                            </van-row>
                        </div>

                        <div v-if="item.content_type === 12" class="article-list-section" style="padding-bottom: 0">
                            <van-row class="article-list-section-box" @click="linkTo(item)">
                                <van-col span="8">
                                    <van-image
                                        fit="cover"
                                        class="article-list-content-img"
                                        :src="item.cover_img"
                                        width="100%"
                                        height="74"
                                    />
                                </van-col>
                                <van-col span="16" class="article-list-content">
                                    <div class="article-list-title">{{item.title}}</div>
                                    <div class="article-list-content-detail">
                                        <div >{{ item.created_at.substring(0,10) }} <span style="margin-left: 8px">{{item.view_count}}人阅读</span></div>
                                    </div>
                                </van-col>
                            </van-row>
                        </div>
                    </div>
                </div>
            </div>
            <!--捐赠通道 -->
            <div class="donate">
                <div class="donate-title">
                    <span class="donate-title-left">捐赠通道</span>
                    <div class="donate-title-right" @click="goList(2, 'more')">
                        <span>查看全部</span>
                        <img src="/static/bytx/public/welfare_list_more_2.svg" alt="">
                    </div>
                </div>
                <div class="donate-swipe">
                    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="red" >
                        <van-swipe-item v-for="(item,i) in donation_channel" :key="i">
                            <a href="javascript:void (0)" @click="clickDonate(item)">
                                <img :src="item.img" alt="">
                            </a>
                        </van-swipe-item>
                    </van-swipe>
                </div>
            </div>
            <!--爱心集市-->
            <div class="donation" ref="hello">
                <div class="donation-title">
                    <span class="donation-title-left">爱心集市</span>
                    <div class="donation-title-right" @click="goList(1, 'more')">
                        <span>查看全部</span>
                        <img src="/static/bytx/public/welfare_list_more_2.svg" alt="">
                    </div>
                </div>
                <div class="donation-box" ref="donation" :style="{height: boxHeight}">
                    <div class="donation-box-wrap" :class="{ 'is-ready': layoutReady }">
                        <div class="donation-box-wrap-item" v-for="(item, index) in waterFullList"
                             :key="index"
                             :style="{ top: item.top + 'px', left: item.left + 'px', width: imgWidth + 'px', height: item.height + 'px'}"
                             @click="itemClick(item)"
                        >
                            <img :src="item.imgs" alt="" :style="{height: item.imgHeight + 'px'}">
                            <div class="donation-box-wrap-item-text" ref="donationText">
                                <span>{{ item.title }}</span>
                                <span>{{ item.author ? `作者: ${item.author}` : ''}}</span>
                                <span>{{ item.desc }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--捐赠进展-->
            <div class="progress" ref="progressRef">
                <div class="progress-box" v-for="(item, index) in donation_progress" :key="index">
                    <img :src="item.src" :style="{height: item.imgheight}">
                </div>
            </div>
            <!--底部 -->
            <div class="bot">
                <p>
                    <a href="javascript:void(0)" @click="go(1)">联系我们</a>
                    <span></span>
                    <a href="javascript:void(0)" @click="applyHelp('')">申请救助</a>
                    <span></span>
                    <a href="javascript:void(0)" @click="go(3)">捐赠通道</a>
                    <span></span>
                    <a href="javascript:void(0)" @click="go(4)">加入志愿者</a>
                </p>
                <p>
                    <img src="/static/bytx/public/welfare_bottom_logo.svg" alt="">
                    <span>爱心不分大小，用爱点亮希望</span>
                </p>
                <!--合作平台暂时隐藏 -->
            </div>
            <!--悬浮窗 -->
            <a href="javascript:void (0)" v-for="(item, index) in iconList" :key="index" :class="`btn${index}`" @click="clickPop(item)">
                <img class="course-detail-home-button" :src="item.img" alt="">
            </a>
            <!--申请救助弹框 -->
            <van-dialog class="apply_form" v-model="applyFormDialog" :showConfirmButton="false">
                <template slot="title">
                    <div class="close-pop" @click="closeApplyForm">
                        <img src="/static/bytx/popup_close_icon.svg" alt="">
                    </div>
                    <h3 v-if="!detail.isApply">申请公益救助</h3>
                    <h3 v-else>您已申请，无需重复提交！</h3>
                </template>
                <div class="clear"></div>
                <div v-if="!detail.isApply">为核实申请信息，为您申请公益救助项目，需您完善真实信息。</div>
                <div v-else style="text-align: center">请将项目名发给小助手，获取报名表或链接</div>
                <div v-if="!detail.isApply" align="center" style="margin-top: 12px;color: #9D9D9D">
                    <van-button class="clinic-detail-footer-right-btn" type="danger" round size="large" @click="goLogin()" color="#0FB7AD">
                        立即填写
                    </van-button>
                </div>
                <div v-else style="text-align: center">
                    <img width="220" src="/static/qrcode/gyjz.png" alt="">
                    <div>长按识别添加</div>
                </div>
            </van-dialog>
            <!--爱心集市查看大图框 -->
            <shade v-show="shadeShow" @close="close" :imgObj="imgObj" :shadeShow="shadeShow"></shade>
        </div>
    </div>
</template>

<script>
import vueWaterfallEasy from 'vue-waterfall-easy'
import Interface from "../../../util/interface";
import publicSkeleton from "@/skeleton/publicSkeleton"
import shade from './component/shade'
import vueSeamlessScroll from 'vue-seamless-scroll'
import checkLogin from "../../../mixins/checkLogin";
import {LocationHref,toHomePage} from '@/util/common'

export default {
    name: "index",
    mixins: [checkLogin],
    components: {
        vueWaterfallEasy,
        publicSkeleton,
        shade,
        vueSeamlessScroll,
    },
    data() {
        return {
            id:0,
            value: '',
            messageArr: [],
            banners: [],
            category_index: 0,
            categories: [
                {id:1,name:"经济救助"},
                {id:2,name:"医疗救助"},
                {id:3,name:"生活帮助"}
            ],
            helpArr: [],
            community_economics: [], // 经济救助
            community_medical: [], // 医疗救助
            community_life: [], // 生活帮助
            cooperation_platform: [], // 合作平台
            donation_channel: [], // 捐赠通道
            imgsArr: [], // 爱心集市
            community_activity: [],  // 公益行动
            donation_progress: [], // 捐赠进展
            iconList: [],  // 悬浮框
            loading: true,
            detail: {},
            formData: {
                name:"",
                mobile:"",
                sex:"男",
                identity_name:"患者本人",
                identity:1,
            },
            applyFormDialog: false,
            shadeShow: false,
            imgObj: {},  // 点击的某个瀑布流
            waterfallDeviationHeight: [], // 瀑布流高度偏移量
            waterFullList: [],
            boxHeight: '',
            layoutReady: false,
            itemBottom: 10,
            imgWidth: 0,
            record_id: 0,
        }
    },
    created() {

        // Interface.listShareInfo(this,1)
        this.init()
        this.getMessage()
        this.getIconList()
        Interface.getShareInfo(this,"公益救助")
        Interface.getData('post',Interface.footprint, {
            id: 1,
            type: 108,
            content_type: 0,
            page_type: 0,
            source_type: 0,
            parent_id: 0,
            record_id: 0,
            title: '公益救助页面'
        }).then( (res) => {
            if (res.code == 0) {
                this.record_id = res.data.record_id
            }
        })
    },
    mounted() {
        this.$nextTick(() => {
            // this.calculationValue()
        })
    },
    beforeRouteLeave(to, from, next) {
        if (this.record_id) {
            Interface.mFootPrint(1, 108,0, 0, 0, 0,this.record_id,'公益救助页面')
        }
        next()
    },
    methods: {
        // 查看更多跳转
        goList(type, location) {
            if (type == 1 && location == 'icon') {
                // 爱心集市
                this.$router.push({path: '/donation'})
                Interface.footPrint(55,0,0,"点击公益首页爱心集市icon")
            } else if (type == 1 && location == 'more') {
                // 爱心集市
                this.$router.push({path: '/donation'})
                Interface.footPrint(24,0,0,"爱心集市-查看更多")
            } else if (type == 2 && location == 'icon') {
                // 捐赠通道
                LocationHref(Interface.url.donation_channel_url)
                Interface.footPrint(54,0,0,"点击公益首页捐赠通道icon")
            } else if (type == 2 && location == 'more') {
                // 捐赠通道
                LocationHref(Interface.url.donation_channel_url)
                Interface.footPrint(35,0,0,"点击公益首页捐赠通道查看更多")
            }else {
                switch (type){
                    case 'medical-assistance' :
                        if (location == 'icon') {
                            Interface.footPrint(52,0,0,"点击公益首页救助项目icon")
                        } else if (location == 'more') {
                            Interface.footPrint(27,0,0,"点击公益首页救助项目查看更多")
                        }
                        break;
                    case 'story' :
                        Interface.footPrint(53,0,0,"点击公益首页病友故事icon")
                        break;
                    case 'what-we-do':
                        Interface.footPrint(43,0,0,"点击公益首页公益行动查看更多")
                        break;
                }
                this.$router.push({
                    name:type,
                })
            }
        },
        toLink(link){
            LocationHref(link)
        },
        // 初始化首页数据
        init() {
            Interface.getData('get', Interface.public.home).then((res) => {
                if (res.code === 0) {
                    // 广告
                    if (res.data && res.data.adverts) {
                        this.banners = res.data.adverts
                    }
                    // 经济救助
                    res.data && res.data.community_economics ? this.community_economics = res.data.community_economics :
                        this.community_economics = []
                    // 医疗救助
                    res.data && res.data.community_medical ? this.community_medical = res.data.community_medical :
                        this.community_medical = []
                    // 生活帮助
                    res.data && res.data.community_life ? this.community_life = res.data.community_life :
                        this.community_life = []
                    // 救助项目默认展示经济救助
                    this.helpArr = this.community_economics
                    // 公益行动
                    res.data && res.data.community_activity ?  this.community_activity = res.data.community_activity :
                        this.community_activity = []
                    // 捐赠通道
                    res.data && res.data.donation_channel ? this.donation_channel = res.data.donation_channel :
                        this.donation_channel = []
                    // 爱心集市
                    res.data && res.data.loving_heart ? this.imgsArr = res.data.loving_heart :
                        this.imgsArr = []
                    //捐赠进展
                    res.data && res.data.donation_progress ? this.donation_progress = res.data.donation_progress :
                        this.donation_progress = []
                    // 合作平台
                    res.data && res.data.cooperation_platform ? this.cooperation_platform = res.data.cooperation_platform :
                        this.cooperation_platform = []
                    setTimeout(() => {
                        this.loading = false
                    }, 500)
                }
            })
            // Interface.footPrint(51,0,0,"访问公益首页")
        },
        // 救助项目标签切换
        tabChange(name, title) {
            if (name == 0) {
                this.helpArr = this.community_economics
            } else if (name == 1) {
                this.helpArr = this.community_medical
            } else if (name == 2) {
                this.helpArr = this.community_life
            }
            Interface.footPrint(28,name,0,"点击公益首页救助项目分类标签")
        },
        go(type) {
            if (type == 1) {
                Interface.footPrint(45,0,0,"点击公益首页尾部联系我们按钮")
                LocationHref(Interface.url.contact_me)
            }else if (type == 3) {
                Interface.footPrint(47,0,0,"点击公益首页尾部捐赠通道按钮")
                LocationHref(Interface.url.donation_channel_url)
            } else if (type == 4) {
                Interface.footPrint(48,0,0,"点击公益首页尾部加入志愿者按钮")
                LocationHref(Interface.url.join_volunteer)
            }
        },
        // 获取滚动消息
        getMessage() {
            Interface.getData('get', Interface.public.message).then((res) => {
                if (res.code == 0) {
                    this.messageArr = res.data
                }
            })
        },
        // 获取icon列表
        getIconList() {
            Interface.getData('get', Interface.public.icon).then((res) => {
                if (res.code == 0) {
                    this.iconList = res.data
                }
            })
        },
        // 公益行动页面跳转
        go_article_detail(item){
            Interface.footPrint(44,item.id,0,item.title)
            if (item.type === 2) {
                this.$router.push({'name': 'article-column', params: {id: item.content_id}})
            } else {
                this.$router.push({'name': 'article-detail', params: {id: item.content_id}})
            }
            Interface.getData("get",Interface.public.content_record+item.id)
        },
        // 公益行动页面跳转
        go_live_detail(item) {
            Interface.footPrint(44,item.id,0,item.title)
            Interface.getData("get",Interface.public.content_record+item.id)

            if (item.type === 2) {
                this.$router.push({'name': 'live-column', params: {id: item.content_id}})
            } else if (item.live_status === 6) {
                this.$router.push({'name': 'live-detail-home', params: {id: item.content_id}})
            } else {
                if (item.live_status === 0) {
                    this.$router.push({'name': 'live-detail', params: {id: item.content_id}})
                } else {
                    this.$router.push({'name': 'live-detail-home', params: {id: item.content_id}})
                }
            }
        },
        // 救助项目跳转
        go_detail(item){
            if(item.id > 46){
                this.$router.push({
                    name : 'community-detail-new',
                    params : {
                        id : item.id
                    }
                })
            }else{
                this.$router.push({
                    name : 'community-detail',
                    params : {
                        id : item.id
                    }
                })
            }
            //Interface.footPrint(29,item.id,0,"点击公益首页救助项目列表")
        },
        // 救助项目点击申请救助
        applyHelp(item) {
            let id = item ? item.id : 0
            Interface.getData('get', Interface.community.detail + id).then((res) => {
                if (res.code == 0) {
                    this.detail = res.data
                    this.applyFormDialog = true
                }
            })
            if (id == 0) {
                Interface.footPrint(46,0,0,"点击公益首页尾部申请救助按钮")
                this.applyFormDialog = true
            }
            this.id = id
        },
        checkPhone(tel){
            return /^1[3456789]\d{9}$/.test(tel);
        },
        // 申请救助
        apply(){
            if(!this.checkPhone(this.formData.mobile)){
                this.$toast.fail("手机号格式不正确")
                return
            }
            switch (this.formData.identity_name){
                case "患者本人":
                    this.formData.identity=1;
                    break;
                case "患者家属":
                    this.formData.identity=2;
                    break;
                case "医务工作者":
                    this.formData.identity=3;
                    break;
                default:
                    this.formData.identity=4;
                    break;
            }
            let params = {
                ...this.formData
            }
            Interface.getData('get', Interface.user.apply_community+this.id,params).then((res) => {
                if(res.code == 0){
                    this.openFeedback = true
                    this.applyFormDialog = false
                }
            })
            Interface.footPrint(31,0,0,"完成救助申请")
        },
        goLogin(){
            //申请
            let user = localStorage.getItem("user");
            user = JSON.parse(user)
            sessionStorage.setItem("back-url", this.$route.path)
            sessionStorage.setItem("apply",JSON.stringify({
                apply:'community',apply_id:this.id
            }))
            this.goAddInfo(user)
        },
        // 关闭申请救助弹框
        closeApplyForm(){
            this.applyFormDialog = false
        },
        // 关闭爱心集市弹框
        close() {
            this.shadeShow = false
        },
        // 瀑布流图片点击
        itemClick(item) {
            this.imgObj = item
            this.shadeShow = true
        },
        changeIdentity() {
            this.$forceUpdate()
        },
        // 点击搜索
        search() {
            this.$router.push({name:'search',query:{form:"community", pageType: 6}})
            Interface.mFootPrint(0,76,0,6,0,0,0,'公益救助-搜索')
            // Interface.footPrint(25,0,0,"点击公益首页搜索")
        },
        // 点击广告打点
        clickAd(item) {
            Interface.footPrint(26,item.id,0,"点击公益首页广告位")
            Interface.getData('get', Interface.public.ad + item.id).then(() => {

            })
        },
        // 点击捐赠通道图片打点
        clickDonate(item) {
            Interface.footPrint1('62', item.id)
            Interface.footPrint(36,item.id,0,"点击公益首页捐赠通道图片")
            Interface.getData('get',Interface.public.td_record+item.id).then(()=>{
                LocationHref(item.link)
            })
        },
        // 点击悬浮窗打点
        clickPop(item) {
            Interface.footPrint(50,item.id,0,"点击公益首页悬浮窗")
            // LocationHref(item.link)
            toHomePage()
        },
        calculationValue() {
            let box = document.querySelector('.donation-box').offsetWidth
            let donationWidth = this.$refs.donation.offsetWidth - 37
            this.imgWidth = donationWidth / 2
            this.waterfallDeviationHeight = new Array(2)
            for(let i = 0; i < this.waterfallDeviationHeight.length; i++){
                this.waterfallDeviationHeight[i] = 0
            }
            this.imgPreloading(this.imgsArr, 0)
        },

        linkTo(item){
            Interface.getData("get",Interface.public.content_record+item.id).then(()=>{
                LocationHref(item.target_url)
            })
        },
        imgPreloading(arr, index) {
            index = index || 0
            if (arr && arr.length > index) {
                let mImg = new Image()
                mImg.src = arr[index].imgs
                mImg.onload = mImg.onerror = (e) => {
                    let itemData = {}
                    let imgHeight = (this.imgWidth / mImg.width) * mImg.height
                    itemData = {...arr[index]}
                    itemData.height = itemData.author ? imgHeight + 180 : imgHeight + 158
                    itemData.imgHeight = imgHeight
                    this.waterFullList.push(itemData)
                    this.waterfallFlowLayout(itemData, arr.length, index);
                    // 加载过程中同步撑起容器高度，避免下方板块（捐赠进展/合作平台）压到瀑布流上面
                    this.boxHeight = Math.max.apply(null, this.waterfallDeviationHeight) + 10 + 'px'
                    this.imgPreloading(arr, index + 1)
                }
            } else if (this.waterFullList.length) {
                // 图片全部加载完成后，用真实渲染高度重新布局，避免作者/简介文字换行导致的高度估算偏差
                this.$nextTick(() => this.correctLayout())
            }
        },
        // 根据文字实际渲染高度修正瀑布流布局
        correctLayout() {
            const textEls = this.$refs.donationText
            this.waterfallDeviationHeight = new Array(2)
            for (let i = 0; i < this.waterfallDeviationHeight.length; i++) {
                this.waterfallDeviationHeight[i] = 0
            }
            this.waterFullList.forEach((item, i) => {
                const textH = textEls && textEls[i] ? textEls[i].offsetHeight : 0
                item.height = item.imgHeight + textH + 24
                this.waterfallFlowLayout(item, this.waterFullList.length, i)
            })
            this.boxHeight = Math.max.apply(null, this.waterfallDeviationHeight) + 16 + 'px'
            // 布局稳定后再显示，避免滚动过程中卡片闪动、文字错位
            this.layoutReady = true
        },
        // 瀑布流布局
        waterfallFlowLayout(itemData, len, index){
            let shortIndex = this.getShortestCol()
            itemData.top = this.waterfallDeviationHeight[shortIndex] + 16
            if (len % 2 == 1 && index == len - 1) {
                itemData.left = 0
            } else {
                itemData.left = shortIndex * (this.imgWidth + 11)
            }
            itemData.left = shortIndex * (this.imgWidth + 11)
            this.waterfallDeviationHeight[shortIndex] += itemData.height + this.itemBottom;
        },
        getShortestCol() {
            const shortest = Math.min.apply(null, this.waterfallDeviationHeight);
            return this.waterfallDeviationHeight.indexOf(shortest);
        }
    },
    watch: {
        'loading': function (newVal, oldVal){
            if (!newVal) {
                this.$nextTick(() => {
                    const rootElePixel = parseInt(window.getComputedStyle(document.querySelector("html"), null).fontSize);
                    this.calculationValue()
                    let boxWidth = this.$refs.progressRef.offsetWidth
                    let arr = []
                    this.donation_progress.forEach((item) => {
                        let mImg = new Image()
                        mImg.src = item
                        mImg.onload = mImg.onerror = (e) => {
                            let itemData = {}
                            let imgHeight = (boxWidth / mImg.width) * mImg.height
                            itemData.imgHeight = imgHeight
                            itemData.src = mImg.src
                            arr.push(itemData)
                        }
                    })
                    this.donation_progress = arr
                })
            }
        }
    }
}
</script>

<style lang="scss">
@import "./index.scss";
</style>



// WEBPACK FOOTER //
// src/views/community/welfare-zone/index.vue